import React, { useContext } from 'react'
import classes from '../pages/destinations/destinations.module.scss'
import ApiContext from '../../utils/api-context'

const DiscoveryGallery = ({ gallery }) => {
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  return (
    <div className={classes.discoverGallery}>
      <div className={classes.discoverGalleryInner}>
        {gallery.map((image, i) => {
          return (
            <div
              className={`${classes.discoverGalleryItem} ${
                image.length === 2
                  ? classes.discoverGalleryDouble
                  : classes.discoverGallerySingle
              }`}
              key={i}
            >
              {image.map((pic, i) => {
                return (
                  <React.Fragment key={i}>
                    <img
                      src={`${pic.image ? pic.image.url : pic.url}`}
                      alt=""
                    />
                  </React.Fragment>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default DiscoveryGallery
